import { useTranslation } from "react-i18next";
import React, { useCallback } from "react";
import { CONTENT_MANAGEMENT_ID } from "@duosoftbg/nacid-components";
import useViewDataObject from "../../../../../hooks/redux/useViewDataObject";
import { getContentManagementDataById } from "../../../../../axios/api/services";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { VIEW_TYPES } from "../../../../../config/view/types";
import ViewPageWrapper from "../../../contacts/ViewPageWrapper";
import HomePageCategoryList from "./HomePageCategoryList";
import { addViewObject } from "../../../../../store/redux/slice/ViewData/viewDataPage";

export const addCategoryViewObject = (data, dispatch) => {
  const viewType = VIEW_TYPES.HOME_PAGE_CATEGORY_EDIT;
  const payload = { viewType, data: data };
  dispatch(addViewObject(payload));
};

const HomePageCategoryManagement = () => {
  const { t } = useTranslation();

  const viewType = VIEW_TYPES.HOME_PAGE_CATEGORY_EDIT;
  const { object, data: categories } = useViewDataObject(viewType);
  const serviceFn = useCallback(getContentManagementDataById(CONTENT_MANAGEMENT_ID.HOME_PAGE_CATEGORY_CONTROL), []);

  return (
    <PageWrapper title={t("t.page.homePageCategory.edit")}>
      <ViewPageWrapper viewType={viewType} serviceFn={serviceFn} object={object}>
        {categories && <HomePageCategoryList categories={categories}></HomePageCategoryList>}
      </ViewPageWrapper>
    </PageWrapper>
  );
};

export default HomePageCategoryManagement;
